import { apiGET } from './api';

export const getUserNotifications = userId => {
  return apiGET(`/users/${userId}/notifications`);
};
